<template lang="pug">
  SspLayout(area="core")
    .alert.alert-info
      i.glyphicon.glyphicon-info-sign
      span.ml5 These words will be refused validation and will not be added to the validation log

    form(role="form" @submit.prevent="add(codeToAdd)")
      .form-group
        .input-group(style="width: 100%; display: block;")
          input.blackword-input.form-control(type="text" v-model="codeToAdd" placeholder="Enter word" style="width: 200px;")
          SspActionButton.ml10(type="submit" text="Add" :disabled="!codeToAdd" :spinning="adding")
          .pull-right
            SspActionButton.remove-all-blackwords-button.btn.btn-danger(type="button" @onClick="removeMultiple(words)" text="Remove All")
      .form-group
        DataGrid(ref="grid" :fetch="load" @error="$emit('error', $event)" :withoutPagination="true")
          tr(slot="thead")
            th Blacklisted word
            th Action
          tr(v-for="word in words")
            td {{word}}
            td.actions
              a.btn-trash(@click='removeWord(word)')
</template>

<script>
import miniToastr from 'mini-toastr'
import DataGrid from '@/components/ssp/DataGrid'
import Core from '@/service/apis/Core'

export default {
  data: () => ({
    adding: false,
    codeToAdd: null,
    words: []
  }),
  methods: {
    load() {
      return Core.codesBlacklist()
        .then((response) => {
          this.words = response.data.code
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    add(word) {
      this.adding = true
      return Core.codesBlacklistAdd([word])
        .then(() => {
          miniToastr.success(`The code "${word}" was added to the black-list`)
          this.codeToAdd = null
          return this.load()
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.adding = false
        })
    },
    removeWord(word) {
      this.$confirm({ text: `Are you sure you want to delete "${word}"?` })
        .then((conf) => {
          if (conf) {
            Core.codesBlacklistRemove([word])
              .then(() => {
                miniToastr.success(`The code "${word}" was removed from the black-list`)
                this.load()
              })
              .catch((e) => {
                this.$emit('error', e)
              })
          }
        })
    },
    removeMultiple(words) {
      this.$confirm({ text: `Are you sure you want to delete <br>"${words}"?` })
        .then((conf) => {
          if (conf) {
            Core.codesBlacklistRemove(words)
              .then(() => {
                miniToastr.success(`The codes "${words}" were removed from the black-list`)
                this.load()
              })
              .catch((e) => {
                this.$emit('error', e)
              })
          }
        })
    }
  },
  components: {
    DataGrid
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/validation/BlackList.vue